// src/pages/Translations.js
import React, { useEffect } from 'react';
import TranslationIntro from '../components/TranslationIntro'; 
import { Link } from 'react-router-dom';

const Translations = () => {
  const img = (path) => process.env.PUBLIC_URL + path;

  useEffect(() => {
    // Re-init AOS if used
    if (window.AOS) {
      window.AOS.init({ once: true });
    }

    // Re-init WOW.js if used
    if (window.WOW) {
      new window.WOW().init();
    }

    // Re-trigger overlay animation logic (if handled in script.js/plugins.js)
    if (typeof window.initCustomAnimations === 'function') {
      window.initCustomAnimations();
    }

    // Fallback: manually trigger overlays (if needed)
    const animatedItems = document.querySelectorAll('[data-animation-text]');
    animatedItems.forEach(el => {
      const animation = el.dataset.animation || 'overlay-animation';
      el.classList.add(animation);
    });

    // Run scrollAnimations() as defined in script.js
    if (window.$ && typeof window.$.fn.scrollAnimations === 'function') {
      const $containers = window.$('[data-animation]:not([data-animation-text]), [data-animation-box]');
      $containers.scrollAnimations();
    }
  }, []);

  return (
    <div className="boxed_wrapper ltr">

      {/* Page Banner */}
      <section
        className="page-title centred pt_130 pb_150"
        style={{
          backgroundImage: "url('/assets/images/banner/translation.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.4)',
            zIndex: 1
          }}
        ></div>
        <div className="pattern-layer" style={{ position: 'relative', zIndex: 2 }}>
          <div className="pattern-1" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-64.png')})` }}></div>
          <div className="pattern-2" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-65.png')})` }}></div>
        </div>
        <div className="auto-container" style={{ position: 'relative', zIndex: 3 }}>
          <div className="content-box">
            <h1 style={{ color: '#fff' }}>Translations</h1>
            <p className="text-white">
              Whether you're expanding your business or connecting with a diverse audience, I deliver translations that help your message make an impact. Contact me today to discuss your project!
            </p>
          </div>
        </div>
      </section>

      {/* ✅ Imported About / Image Section */}
      <TranslationIntro />

      {/* Features Section */}
      <section className="feature-style-two pb_120 centred">
        <div className="auto-container">
          <div className="sec-title mb_55">
            <span className="sub-title overlay-anim-white-bg">Translations Service</span>
            <h2>Why Choose Translations Services</h2>
          </div>
          <div className="row clearfix">
            {[
              {
                icon: 'icon-16',
                title: 'Industry Expertise',
                text: 'Specializing in fields like legal, marketing translations.'
              },
              {
                icon: 'icon-17',
                title: 'Cultural Sensitivity',
                text: 'Tailored translations that respect local customs and preferences.'
              },
              {
                icon: 'icon-18',
                title: 'Accuracy and Quality',
                text: 'Ensuring the original message and tone are preserved.'
              },
              {
                icon: 'icon-21',
                title: 'Timely Delivery',
                text: 'Wications Provide reliable service that meets your deadlines.'
              }
            ].map((item, idx) => (
              <div key={idx} className="col-lg-3 col-md-6 col-sm-12 feature-block">
                <div className="feature-block-one">
                  <div className="inner-box">
                    <div className="icon-box"><i className={item.icon}></i></div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="bg-color"></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              {[23, 24, 25, 26].map(n => (
                <div
                  key={n}
                  className={`pattern-${n - 22} ${n !== 23 ? 'rotate-me' : ''}`}
                  style={{ backgroundImage: `url(${img('/assets/images/shape/shape-${n}.png')})` }}
                ></div>
              ))}
            </div>
            <div className="inner-box">
              <h2>Let’s Bridge the Language Gap – <br />Get Started Now</h2>
             <div className="btn-box pt-3">
                             <Link to="/contact" className="theme-btn btn-one">Get Started</Link>
                           </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Translations;